// GENERATED FILE. Do not edit by hand. Produced by `bun run codegen`.

import Ajv from "ajv";
import addFormats from "ajv-formats";
import call from "../../sdk-helpers/call";
import { logError } from "../../sdk-helpers/shouldLog";

export type typeIdentityGetBody = {};

export type typeIdentityGetOutput200 = {
  error?: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data?: null | {
    userId: string;
    email?: string | null;
    isSuperAdmin: boolean;
    sessionId: string;
  };
};

export type typeIdentityGetOutput400 = {
  error: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data: null;
};

export type typeIdentityGetOutput401 = {
  error: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data: null;
};

export type typeIdentityGetOutput500 = {
  error: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data: null;
};

export const schemaIdentityGetBody = {
  type: "object",
  properties: {},
} as const;

export type SdkOptions = {
  headers?: Record<string, string>;
  apiHost?: string;
  prefix?: string;
};

let compiledValidator: ReturnType<Ajv["compile"]> | null = null;

export default function createIdentityGet(options: SdkOptions) {
  if (!compiledValidator) {
    const ajv = new Ajv({ strict: false });
    addFormats(ajv);
    compiledValidator = ajv.compile(schemaIdentityGetBody);
  }

  return async function postIdentityGet(
    payload: typeIdentityGetBody,
  ): Promise<typeIdentityGetOutput200 | typeIdentityGetOutput400> {
    const isValid = compiledValidator!(payload);
    if (!isValid) {
      logError(
        `Payload validation inside SDK method "postIdentityGet" failed before calling the network. #1c22ace43100`,
        compiledValidator!.errors,
      );
      return {
        error: {
          code: "VALIDATION_ERROR",
          message: "Request payload failed schema validation.",
          details: { errors: compiledValidator!.errors, ref: "#1c22ace43100" },
        },
        data: null,
      } as typeIdentityGetOutput400;
    }

    const prefix = options?.prefix ?? "";
    return (await call({
      payload,
      endpoint: `${prefix}/identity/get`,
      httpMethod: "POST",
      options,
    })) as typeIdentityGetOutput200 | typeIdentityGetOutput400;
  };
}
